import { type ReactNode } from "react";
import { atom } from "nanostores";

type PendingActionsBannerContent = ReactNode | null;

export const $pendingActionsBanner = atom<PendingActionsBannerContent>(null);

export const pendingActionsBannerActions = {
  setBanner: (content: PendingActionsBannerContent) => {
    $pendingActionsBanner.set(content);
  },
  clearBanner: () => {
    $pendingActionsBanner.set(null);
  },
};
